import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Grid2,
    Typography,
    Link,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
} from "@mui/material";
import { ReactComponent as CloseIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"

const ConsentNotice = (props) => {
    const { pValue } = props;
    const navigate = useNavigate();


   
    const rows = [
        { id: 1, type: "Work Email", purpose: "Identify, authorise and authenticate users, including for access control purpose." },
        { id: 2, type: "First & Last Name", purpose: "Enable users to identify one another" },
        { id: 3, type: "Phone Number", purpose: "Operate, administer, manage and improve the application." }
    ];
    const retentionPreiod = [
        { id: 1, type: "Work Email", purpose: "Till the lifetime of the project user is part of." },
        { id: 2, type: "First & Last Name", purpose: "Till the lifetime of the project user is part of" },
        { id: 3, type: "Phone Number", purpose: "Till the lifetime of the project user is part of." },
        { id: 4, type: "Automated System Logs", purpose: "The standard default Data Retention Period for such automated system logs has been set to one year." },
        { id: 5, type: "Client Specific data / process captured by solution", purpose: "The client data shall be retained for the period agreed in cluent engagement letter." }
    ];  

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: pValue?.px,
                py: pValue?.py,
                backgroundColor: pValue?.bg,
            }}
        >
            <Box
                sx={{
                    maxWidth: "1000px",
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 2,
                    boxShadow: 2,
                    position: "relative",
                }}
            >
                {pValue?.py != 1 &&
                    <IconButton
                        aria-label="close"
                        onClick={() => navigate(-1)}
                        sx={{ position: "absolute", top: 8, right: 8 }}
                    >
                        <CloseIcon style={{ height: "20px", width: "20px" }} />
                    </IconButton>
                }


                <Typography variant="h4" align="center" gutterBottom>
                    Consent Notice
                </Typography>


                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body1" sx={{ minWidth: "40px", fontWeight: "bold" }}>
                            1.1
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify" }}>
                            This consent notice (‘Notice’) is to inform you of how we, PricewaterhouseCoopers Private Limited, want to process your personal data, so that you may give your informed consent.
                        </Typography>
                    </Box>
                </Box>


                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>

                        <Typography
                            variant="body1"
                            sx={{ minWidth: "40px", fontWeight: "bold" }}
                        >
                            1.2
                        </Typography>


                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body1" sx={{ textAlign: "justify", mb: 2 }}>
                                We will only collect, hold, store and process, both electronically and
                                physically, as much personal data as is necessary for the purposes
                                mentioned in this Notice. The personal data will not be used for any
                                other purpose except to the extent we need to use it for any other
                                purpose which falls within certain legitimate uses as prescribed under
                                applicable laws including fulfilling any obligation under applicable
                                law. Only the following personal data will be collected from you for the
                                purposes mentioned in this Notice:
                            </Typography>


                            <TableContainer
                                sx={{ border: "1px solid #ccc" }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: "1px solid #ccc" }}>
                                                <b>Sl. No.</b>
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #ccc" }}>
                                                <b>Type of Personal Data Collected</b>
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #ccc" }}>
                                                <b>Purpose of Collection</b>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell sx={{ border: "1px solid #ccc" }}>{row.id}</TableCell>
                                                <TableCell sx={{ border: "1px solid #ccc" }}>{row.type}</TableCell>
                                                <TableCell sx={{ border: "1px solid #ccc" }}>{row.purpose}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </Box>



                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body1" sx={{ minWidth: "40px", fontWeight: "bold" }}>
                            1.3
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify" }}>
                            You confirm that to the extent you provide any personal data of any other person, they or (in the case of persons below 18 years of age or persons with disability) their parent or lawful guardian, as applicable, have communicated their free, specific, informed, unconditional and unambiguous consent (in terms of Clause 1.2 above) to our processing of their personal data (as contemplated by this Notice), by clear affirmative action and have duly authorized you to communicate such consent to us. Where you are the parent or guardian of such other person, you consent to the processing of the personal data of such persons for the purposes contemplated in this Notice.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>

                        <Typography
                            variant="body1"
                            sx={{ minWidth: "40px", fontWeight: "bold" }}
                        >
                            1.4
                        </Typography>


                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body1" sx={{ textAlign: "justify", mb: 2 }}>
                                We will process your personal data only till the purposes mentioned are served, as specified below:
                            </Typography>


                           <TableContainer
                                sx={{ border: "1px solid #ccc" }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: "1px solid #ccc" }}>
                                                <b>Sl. No.</b>
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #ccc" }}>
                                                <b>Type of Personal Data Collected</b>
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #ccc" }}>
                                                <b>Period of Retention</b>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {retentionPreiod.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell sx={{ border: "1px solid #ccc" }}>{row.id}</TableCell>
                                                <TableCell sx={{ border: "1px solid #ccc" }}>{row.type}</TableCell>
                                                <TableCell sx={{ border: "1px solid #ccc" }}>{row.purpose}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body1" sx={{ minWidth: "40px", fontWeight: "bold" }}>
                            1.5
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify" }}>
                            As part of a global network of PricewaterhouseCoopers firms (each of which is a separate legal entity), we exchange or may need to exchange personal data within the network or with other overseas service providers/contractors working and acting on our behalf. As a result, we may transfer personal data outside India to other countries whose privacy laws provide different levels of protection. We may also use overseas facilities to process, host or back up the personal data. As a result, we may need to transfer personal data to our overseas facilities for these purposes. However, any such personal data transferred shall be subject to appropriate data protection obligations and requirements under applicable law. You hereby consent to the transfer, storage and processing by us, our agents, contractors, subcontractors or other PricewaterhouseCoopers firms, of such personal data within or outside India in accordance with the above.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body1" sx={{ minWidth: "40px", fontWeight: "bold" }}>
                            1.6
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify" }}>
                            You have the right to i) access your personal data information provided by you; ii) correct and update your personal data; iii) erase your personal data; iv) seek redress of any grievance regarding processing of personal data as stated herein; and v) nominate someone to exercise rights in case of death or incapacity.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>

                        <Typography
                            variant="body1"
                            sx={{ minWidth: "40px", fontWeight: "bold" }}
                        >
                            1.7
                        </Typography>


                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body1" paragraph sx={{ textAlign: "justify", mb: 2 }}>
                                <span style={{ textDecoration: "underline" }}>You can withdraw your consent for processing of your personal data at any time</span>, signified by your clear affirmative action by raising your request 
                                <Link
                                target="_blank"
                                href="https://privacyportal-eu.onetrust.com/webform/f13f2198-97ab-4c25-a5cd-0fca8ada2e21/b4e47c5a-ca49-419b-85de-0e1f7f6457e">
                                &nbsp;here.
                            </Link>
                            In the event you continue to have any grievance in relation to the processing of your personal data or your rights, you may also register any grievance by mailing at [in_privacy.in@pwc.com].. <span style={{ textDecoration: "underline" }}>If you do so, your personal data will be erased, unless there is any legal requirement to retain it</span>.
                            </Typography>
                            <Typography variant="body1" sx={{ textAlign: "justify", mb: 2 }}>
                                In case you choose to subsequently withdraw your consent, the consequences of such withdrawal shall be borne by you, and such withdrawal shall not affect the legality of processing of the personal data based on your consent prior to such withdrawal.
                            </Typography>

                        </Box>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body1" sx={{ minWidth: "40px", fontWeight: "bold" }}>
                            1.8
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify" }}>
                            You confirm that that you have not suppressed any material information while providing your personal data.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>

                        <Typography
                            variant="body1"
                            sx={{ minWidth: "40px", fontWeight: "bold" }}
                        >
                            1.9
                        </Typography>


                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body1" paragraph sx={{ textAlign: "justify", mb: 2 }}>
                                In case of any questions regarding our processing of your personal data, you may contact us details referenced in 1.7 section.
                            </Typography>

                            <Typography variant="body1" paragraph sx={{ textAlign: "justify", mb: 2 }}>
                                You can also register any grievance by mailing at [<Box component="span" sx={{color:"#0000EE"}}>in_privacy.in@pwc.com</Box>]. 
                            </Typography>

                        </Box>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body1" sx={{ minWidth: "40px", fontWeight: "bold" }}>
                            1.10
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify" }}>
                            This Notice shall be governed by the laws of India, and the parties hereby submit to the exclusive jurisdiction of the competent courts of New Delhi, India.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body1" sx={{ minWidth: "40px", fontWeight: "bold" }}>
                            1.11
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ textAlign: "justify", fontWeight: "bold" }}>
                            You hereby communicate your free, specific, informed, unconditional and unambiguous consent (in terms of Clauses 1.4, 1.5 and 1.6 below) to our processing of your personal data, for the purposes as specified in Clause 1.3 below.
                        </Typography>
                    </Box>
                </Box>
            </Box>

        </Box>
    );
};

export default ConsentNotice;
